(() => {
  const DESKTOP_QUERY = '(min-width: 64rem)';
  const REDUCE_QUERY = '(prefers-reduced-motion: reduce)';
  const SKIP_PATHS = ['/checkout', '/account', '/admin'];

  function prefersReducedMotion() {
    return window.matchMedia(REDUCE_QUERY).matches;
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function skipPath(url) {
    if (!url) return false;
    try {
      const path = new URL(url, window.location.origin).pathname;
      return SKIP_PATHS.some((prefix) => path.includes(prefix));
    } catch {
      return false;
    }
  }

  function shouldSkip(event) {
    if (prefersReducedMotion() || !isDesktop() || window.Shopify?.designMode) {
      return true;
    }
    return (
      skipPath(event.activation?.entry?.url) ||
      skipPath(event.activation?.from?.url)
    );
  }

  function cancelOnInteraction(viewTransition) {
    const cancel = () => viewTransition.skipTransition();
    document.addEventListener('pointerdown', cancel, {once: true});
    document.addEventListener('keydown', cancel, {once: true});
    viewTransition.finished.finally(() => {
      document.removeEventListener('pointerdown', cancel);
      document.removeEventListener('keydown', cancel);
    });
  }

  function handleViewTransition(event) {
    const viewTransition = event.viewTransition;
    if (!viewTransition) return;
    if (shouldSkip(event)) {
      viewTransition.skipTransition();
      return;
    }
    cancelOnInteraction(viewTransition);
  }

  window.addEventListener('pageswap', handleViewTransition);
  window.addEventListener('pagereveal', handleViewTransition);
})();
